<template>
    <div class="col-sm-12 bg-lightest border-light card-height-2 d-flex flex-column radius-normal">
        <div class="">
            <div class="text-center darker font-weight-600 mt-4 fs-large">
                Download Reports
            </div>

            <div class="dark text-center fs-small mb-2">
                {{ subTitle }}
            </div>
        </div>

        <div class="col-sm-12 mb-4 d-flex justify-content-between flexGrow1 overflow-auto">
            <div class="row">
                <div class="downloadCard my-1 pointer d-flex flex-row col-sm-4 align-items-center position-relative"
                    :class="{ 'opacity-50 notAllowed': report.downloading }" v-for="(report, index) in reports"
                    :key="index" @click="downloadReport(report)"
                    v-if="report.active && accessPermissionFilter(report.allowedToAccess)">
                    
                    <div v-if="report.downloading"
                        class="loadingHolder d-flex justify-content-center align-items-center">
                        <loader size="small"></loader>
                    </div>

                    <div v-else>
                        <div v-if="report.fileType == 'xlsx'">
                            <svg class="downloadIcon small" version="1.1" id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;"
                                xml:space="preserve">
                                <g>
                                    <path
                                        d="M108.862,372.031l10.871-18.109c2.437-4.007,4.606-7.821,6.52-11.439l1.6-2.976h0.224l1.6,2.931l1.54,2.976
                                c1.51,2.871,3.095,5.712,4.755,8.509l10.826,18.109h16.778l-24.135-38.879l22.64-36.487h-16.898l-10.049,16.838
                                c-1.764,2.946-3.23,5.563-4.411,7.836l-1.376,2.602c-0.299,0.583-0.763,1.466-1.391,2.647h-0.209l-1.391-2.647l-1.376-2.662
                                c-1.406-2.572-2.886-5.189-4.471-7.836l-10.049-16.778H93.4l22.969,36.487l-24.733,38.879H108.862z" />
                                    <polygon
                                        points="219.459,359.216 184.124,359.216 184.124,296.665 169.813,296.665 169.813,372.031 219.459,372.031 	" />
                                    <path
                                        d="M255.408,361.204c-8.21,0-13.234-0.583-15.073-1.764c-1.839-1.181-2.766-4.396-2.766-9.66l-0.045-1.6h-13.922l0.06,2.751
                                c0,8.763,1.944,14.58,5.817,17.451c3.888,2.871,11.754,4.307,23.612,4.307c13.174,0,21.698-1.466,25.571-4.381
                                c3.858-2.931,5.802-9.406,5.802-19.41c0-8.135-1.66-13.488-4.95-16.075c-3.29-2.572-10.557-4.172-21.787-4.8
                                c-9.495-0.508-15.088-1.256-16.778-2.213c-1.705-0.957-2.542-3.813-2.542-8.553c0-4.008,1.032-6.639,3.11-7.895
                                c2.079-1.256,6.505-1.884,13.279-1.884c5.757,0,9.406,0.553,10.946,1.63c1.54,1.092,2.482,3.753,2.811,7.985
                                c0,0.329,0.045,0.837,0.12,1.54h13.967v-2.871c0-7.806-1.974-13.04-5.907-15.731c-3.948-2.692-11.574-4.038-22.924-4.038
                                c-11.963,0-19.948,1.466-23.941,4.396c-3.993,2.916-5.981,8.793-5.981,17.585c0,8.613,1.645,14.221,4.965,16.838
                                c3.305,2.617,10.931,4.277,22.864,4.965l7.896,0.508c4.456,0.254,7.357,0.987,8.703,2.183c1.331,1.196,2.004,3.604,2.004,7.253
                                c0,4.935-0.882,8.09-2.647,9.451C265.905,360.532,261.808,361.204,255.408,361.204z" />
                                    <path
                                        d="M304.665,372.031l10.871-18.109c2.437-4.007,4.606-7.821,6.52-11.439l1.6-2.976h0.224l1.6,2.931l1.54,2.976
                                c1.51,2.871,3.095,5.712,4.755,8.509l10.826,18.109h16.778l-24.12-38.879l22.64-36.487h-16.898l-10.049,16.838
                                c-1.78,2.946-3.245,5.563-4.426,7.836l-1.376,2.602c-0.299,0.583-0.763,1.466-1.376,2.647h-0.224l-1.376-2.647l-1.391-2.662
                                c-1.391-2.572-2.886-5.189-4.471-7.836l-10.049-16.778h-17.062l22.969,36.487l-24.733,38.879H304.665z" />
                                    <path d="M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413
                                H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z" />
                                </g>
                            </svg>
                        </div>

                        <div v-if="report.fileType == 'pdf'">
                            <svg class="downloadIcon small" version="1.1" id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;"
                                xml:space="preserve">
                                <g>
                                    <path d="M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413
                                H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z" />
                                    <path
                                        d="M172.819,296.665h-3.753h-30.371v75.366h14.303v-24.344h16.845l3.312-0.06c10.303,0,17.152-1.66,20.539-4.965
                                c3.387-3.32,5.077-10.019,5.077-20.113c0-10.154-1.772-17.017-5.324-20.561C189.896,298.429,183.017,296.665,172.819,296.665z
                                    M181.627,333.406c-1.75,1.495-5.862,2.243-12.337,2.243h-16.292v-26.946h17.728c6.109,0,9.892,0.763,11.342,2.288
                                c1.458,1.525,2.183,5.473,2.183,11.843C184.251,328.396,183.376,331.91,181.627,333.406z" />
                                    <path
                                        d="M244.94,296.665h-37.055v75.366h37.496c11.888,0,19.537-2.677,22.916-8.03c3.379-5.353,5.084-17.451,5.084-36.263
                                c0-11.514-2.123-19.574-6.325-24.18C262.84,298.953,255.467,296.665,244.94,296.665z M255.841,355.268
                                c-2.004,3.155-6.43,4.725-13.279,4.725h-20.374v-51.291h21.257c6.662,0,10.901,1.495,12.703,4.516
                                c1.802,3.021,2.707,10.094,2.707,21.204C258.854,345.174,257.853,352.128,255.841,355.268z" />
                                    <polygon points="283.82,372.031 298.115,372.031 298.115,341.047 331.91,341.047 331.91,329.009 298.115,329.009 298.115,308.702
                                333.735,308.702 333.735,296.665 283.82,296.665 	" />
                                </g>
                            </svg>
                        </div>
                    </div>

                    <div class="ml-2 d-flex flex-column align-items-start">
                        <span class="fs-normal darker bold">{{ report.name }}</span>
                        <span class="fs-smaller dark" v-if="report.subName">{{ report.subName }}</span>
                        <span v-if="report.downloading" class="dark fs-smaller">Downloading</span>
                        <span v-if="report.downloadError" class="dark fs-smaller color-6">Error downloading</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'

    export default {
        mixins: [],
        data() {
            return {
                reportsBase: [
                    {
                        name: 'Agents',
                        subName: 'by sale date',
                        url: '/api/Booking/ReportingBookingSalesDownload',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        params: {
                            's.onlyAgents': true
                        },
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor'
                        ]
                    },
                    {
                        name: 'Agents',
                        subName: 'by departure date',
                        url: '/api/Report/ReportingAgentByEventsDownload',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        params: {
                            's.onlyAgents': true
                        },
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor'
                        ]
                    },
                    {
                        name: 'Agent Sales',
                        url: '/api/report/DownloadPDFAgentsSales',
                        fileType: 'pdf',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        specialRequest: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor'
                        ]
                    },
                    {
                        name: 'Agent Sales',
                        subName: 'by product',
                        url: '/api/Report/AgentsPerExperienceAndPerResourceType',
                        fileType: 'pdf',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        specialRequest: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor'
                        ]
                    },
                    {
                        name: 'Totals by Agent',
                        url: '/api/Report/ReportSupplierAgentTotals',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor'
                        ]
                    },
                    {
                        name: 'Sales',
                        url: '/api/Booking/ReportingBookingSalesDownload',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor'
                        ]
                    },
                    {
                        name: 'Sales',
                        url: '/api/Report/ReportingAgentByEventsDownload',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: false,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor'
                        ]
                    },
                    {
                        name: 'Extras Sales',
                        url: '/api/Report/BookingExtraReport',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Daily Summary',
                        url: '/api/report/dailysummary',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Team Resume',
                        url: '/api/report/MyTeamResume',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Widget Summary',
                        url: '/api/report/WidgetSummary',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        name: 'Product Daily Sales',
                        url: '/api/report/ReportBooking_DepartureGroupingSales',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Event Resume',
                        url: '/api/Report/EventResume',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Event Departure Sales',
                        url: '/api/report/ReportBooking_EventDailySales',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Widget Abandons',
                        url: '/api/report/WidgetAbandons',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'myTeamSupervisor'
                        ]
                    },
                    {
                        name: 'Product Totals',
                        url: '/api/report/ReportBooking_DepartureGroupingSalesByProduct',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        name: 'Resource Totals',
                        url: '/api/report/ReportBooking_DepartureGroupingSalesByResource',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor'
                        ]
                    },
                    {
                        name: 'Country Sales',
                        url: '/api/Report/ReportBooking_SalesGroupByProductCountry',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        name: 'Country Departures',
                        url: '/api/Report/ReportBooking_DeparturesGroupByProductCountry',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        name: 'Pluralo Locals',
                        url: '/api/Report/DownloadPDFPluraloLocals',
                        fileType: 'pdf',
                        downloading: false,
                        downloadError: false,
                        active: true,
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        uid: 'gyg',
                        name: 'Get Your Guide',
                        url: '/api/Report/DownloadPDFOTAs',
                        params: {
                            's.ChannelType': 202 // Get Your Guide
                        },
                        fileType: 'pdf',
                        downloading: false,
                        downloadError: false,
                        active: function (vm) { return vm.getActiveIntegrations.getYourGuide },
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        uid: 'viator',
                        name: 'Viator',
                        url: '/api/Report/DownloadPDFOTAs',
                        params: {
                            's.ChannelType': 203 // Viator
                        },
                        fileType: 'pdf',
                        downloading: false,
                        downloadError: false,
                        active: function (vm) { return vm.getActiveIntegrations.viator },
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'agentSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                    {
                        name: 'Bookings',
                        uid: 'bookings',
                        subName: 'Without Invoice',
                        url: '/api/Report/ReportBookingItemsWithoutInvoice',
                        fileType: 'xlsx',
                        downloading: false,
                        downloadError: false,
                        active: function (vm) { return vm.hasInvoiceSystem },
                        allowedToAccess: [
                            'admin',
                            'mainSupervisor',
                            'marketingSupervisor'
                        ]
                    },
                ]
            }
        },
        props: [
            'subTitle',
            'dateFrom',
            'dateTo',
        ],
        computed: {
            ...mapGetters([
                'account',
                'getActiveIntegrations',
                'getAllIntegrations',
                'getHasInvoiceSystem',
            ]),
            filename() {
                if (this.dateFrom == this.dateTo) {
                    return this.dateFrom;
                } else {
                    return this.dateFrom + '_to_' + this.dateTo;
                }
            },
            reports: {
                get() {
                    let reports = this.reportsBase

                    // This allows to have dynamic "active" and keeping the "downloading" flag able to be used
                    reports = reports.map(report => {
                        if (typeof report.active == 'function') {
                            report.active = report.active(this);
                        }

                        return report;
                    })

                    return reports;
                },
                set(newVal) {}
            },
            hasInvoiceSystem() {
                return this.getHasInvoiceSystem ? this.getHasInvoiceSystem : false;
            },
        },
        methods: {
            downloadReport(report) {
                if (report.downloading) {
                    this.$toasted.info('Already downloading, please wait');

                    return false;
                }

                let prefix = report.specialRequest ? 'request.' : 's.';

                let requestParams = {
                    [`${prefix}supplierId`]: this.account.supplierId,
                    [`${prefix}dateStart`]: this.dateFrom,
                    [`${prefix}dateEnd`]: this.dateTo
                };

                // If the report has special params this merges them with the request params
                Object.assign(requestParams, report.params);
                report.downloading = true;
                report.downloadError = false;

                axios.get(report.url, {
                    params: requestParams,
                    responseType: 'blob'
                }).then(response => {
                    report.downloading = false;
                    
                    if (response.status == 200) {
                        window.URL = window.URL || window.webkitURL;
                        const headers = response.headers;
                        const blob = new Blob([response.data], { type: headers['content-type'] });
                        const link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = window.URL.createObjectURL(blob);
                        link.download = report.name + '_' + this.filename + '.' + report.fileType;
                        link.click();
                    }
                }).catch(error => {
                    report.downloading = false;
                    report.downloadError = true;
                })
            },
            resetDownloads() {
                for (let report of this.reports) {
                    report.downloadError = false;
                }
            },
        },
        watch: {
            dateFrom: {
                handler() {
                    this.resetDownloads();
                }
            },
            dateTo: {
                handler() {
                    this.resetDownloads();
                }
            },
        },
        components: {
            Loader,
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .downloadCard {
        &:hover {
            background-color: $lighter;
            border-radius: 5px;
        }
    }

    .downloadIcon {
        height: 60px;
        fill: $dark;
        transition: all ease-in-out 200ms;

        &.small {
            height: 35px;
        }

        &:hover {
            transform: scale(1.04);
        }
    }

    .loadingHolder {
        background: rgba(255, 255, 255, 0.5);
        width: 35px;
        height: 40px;
    }
</style>



// WEBPACK FOOTER //
// cardDownload.vue?4c5adf70